import { Button } from '@/shadcn-ui/button';

export interface CalculatorSalesPitchCallToActionProps {
  isOnPDP?: boolean;
  showSavingsCalculatorV2: boolean;
}

export default function CalculatorSalesPitchCallToAction({
  isOnPDP,
  showSavingsCalculatorV2,
}: CalculatorSalesPitchCallToActionProps) {
  return (
    <>
      {isOnPDP && !showSavingsCalculatorV2 ? (
        <Button
          variant="clear"
          className="relative z-10 h-10 w-auto rounded-3xl border-[1.5px] border-flexcar-neutral1 px-6 py-3 font-bold uppercase leading-3 tracking-widest text-flexcar-neutral1 hover:border-flexcar-neutral50"
        >
          Show me how
        </Button>
      ) : null}
      {showSavingsCalculatorV2 ? (
        <Button
          variant="clear"
          className="relative z-10 h-10 w-auto rounded-3xl border-[1.5px] border-flexcar-neutral1 px-6 py-3 font-bold uppercase leading-3 tracking-widest text-flexcar-neutral1 hover:border-flexcar-neutral50"
        >
          Calculate my savings
        </Button>
      ) : null}
      {!isOnPDP && !showSavingsCalculatorV2 ? (
        <p className="body-strong text-flexcar-neutral1">
          See savings calculation {'->'}
        </p>
      ) : null}
    </>
  );
}
